import React from "react";
import QuillHtmlContent from "../../../components/common/QuillHtmlContent";

const DEFAULT_DETAILS =
  "Below you will find a series of statements about you. Read each statement and decide how much you agree or disagree with that statement. Do not select answers based on what you perceive would be the desirable response, as there are no right or wrong answers for this survey. The goal is to choose the response that reflects the natural way you feel or think. Please answer every statement, even if you are not completely sure of your response.";

export interface InstructionProps {
  details?: string;
}

const Instruction: React.FC<InstructionProps> = ({
  details = DEFAULT_DETAILS,
}) => {
  return (
    <div className="flex flex-col items-center  text-[#374151]  justify-center py-8 min-h-0">
      {/* <div
        className="max-w-[720px] text-center text-[#374151] font-primary text-[16px] leading-[1.6] [&_p]:mb-2 [&_p:last-child]:mb-0 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5"
        style={{ fontFamily: "var(--font-primary)" }}
        dangerouslySetInnerHTML={{ __html: details }}
      /> */}

      <QuillHtmlContent html={details ?? ""} />
    </div>
  );
};

export default Instruction;
